export const orderByValue = (oldValue: string, newValue: string) => {
	let numberedOldValue = Number(oldValue.replaceAll('R$', '').replaceAll('.', '/').replaceAll(',', '.').replaceAll('/', ''));
	let numberedNewValue = Number(newValue.replaceAll('R$', '').replaceAll('.', '/').replaceAll(',', '.').replaceAll('/', ''));
	let retorno = (!!numberedOldValue ? numberedOldValue : 0) - (!!numberedNewValue ? numberedNewValue : 0);
	return retorno;
};

export const orderByDate = (dateA: string | null | undefined, dateB: string | null | undefined) => {
	if (!dateA && !dateB) return 0;
	if (!dateA) return -1;
	if (!dateB) return 1;

	const [dayA, monthA, yearA] = dateA.split('/').map(Number);
	const [dayB, monthB, yearB] = dateB.split('/').map(Number);

	const timestampA = new Date(yearA, monthA - 1, dayA).getTime();
	const timestampB = new Date(yearB, monthB - 1, dayB).getTime();

	if (isNaN(timestampA) && isNaN(timestampB)) return 0;
	if (isNaN(timestampA)) return -1;
	if (isNaN(timestampB)) return 1;

	return timestampA - timestampB;
};